import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
  HttpStatusCode,
} from '@angular/common/http';
import { message } from '@i18n/languages/jp/message';
import { HttpResponse } from '@shared/models/http.response';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export class HttpService {
  constructor(protected http: HttpClient) {}

  private generateParamsFrom(params?: any): HttpParams {
    let httpParams = new HttpParams();
    for (const item in params) {
      if (
        params.hasOwnProperty(item) &&
        params[item] !== undefined &&
        params[item] !== null &&
        params[item] !== ''
      ) {
        httpParams = httpParams.set(item, params[item]);
      }
    }
    return httpParams;
  }

  private toPromise(
    observable: Observable<HttpResponse<any>>,
  ): Promise<HttpResponse<any>> {
    return new Promise((resolve) => {
      observable.subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === HttpStatusCode.InternalServerError) {
              resolve({
                statusCode: HttpStatusCode.InternalServerError,
                message: message.internalServerError,
              });
            } else if (err.status === 0) {
              const isCorsError =
                err.statusText === 'Unknown Error' ||
                err.error instanceof ProgressEvent ||
                !navigator.onLine === false;
              if (isCorsError) {
                resolve({
                  statusCode: HttpStatusCode.Forbidden,
                  message: message.forbidden,
                });
              } else {
                resolve({
                  statusCode: 0,
                  message: message.internalServerError,
                });
              }
            } else {
              err.error.message = Array.isArray(err.error?.message)
                ? err.error?.message[0]
                : err.error?.message;
              resolve(err.error);
            }
          } else {
            resolve({
              statusCode: HttpStatusCode.InternalServerError,
              message: message.internalServerError,
            });
          }
        },
      });
    });
  }

  protected getAsync(path: string, params?: any) {
    const httpParams = this.generateParamsFrom(params);
    return this.toPromise(
      this.http.get<HttpResponse<any> | any>(
        `${environment.endpoint}/${path}`,
        {
          params: httpParams,
        },
      ),
    );
  }

  protected postAsync(
    path: string,
    request?: any,
    params?: any,
  ): Promise<HttpResponse<any>> {
    const httpParams = this.generateParamsFrom(params);
    return this.toPromise(
      this.http.post<HttpResponse<any> | any>(
        `${environment.endpoint}/${path}`,
        request,
        { params: httpParams },
      ),
    );
  }

  protected putAsync(
    path: string,
    request?: object,
  ): Promise<HttpResponse<any>> {
    return this.toPromise(
      this.http.put<HttpResponse<any> | any>(
        `${environment.endpoint}/${path}`,
        request,
      ),
    );
  }

  protected patchAsync(
    path: string,
    request?: object,
  ): Promise<HttpResponse<any>> {
    return this.toPromise(
      this.http.patch<HttpResponse<any> | any>(
        `${environment.endpoint}/${path}`,
        request,
      ),
    );
  }

  protected deleteAsync(path: string): Promise<HttpResponse<any>> {
    return this.toPromise(
      this.http.delete<HttpResponse<any> | any>(
        `${environment.endpoint}/${path}`,
      ),
    );
  }
}
